import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import { hasAssignments } from '@/shared/components/security/HasAssignments';
import { ColumnHeader, ScrollableTable } from '@/shared/components/table';
import RelationName from '@/shared/components/RelationName';

const messages = defineMessages({
  InvoicedRelations: 'Invoiced relations',
  Relation: 'Relation',
  Assignment: 'Assignment',
});

class InvoicedRelationsModal extends Component {
  state = {};

  static propTypes = {
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
    relationId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    show: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      relations: [],
      showAssignments: hasAssignments(),
    };
  }

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  // eslint-disable-next-line class-methods-use-this
  renderRelation = relation => (
    <tr key={relation.id}>
      <td>
        <RelationName key={relation.id} relation={relation} />
      </td>
      <td>{relation.assignmentName}</td>
    </tr>
  );

  loadRelations = parameters => {
    const { relationId, intl } = this.props;
    console.log('loading', parameters);
    return api.base
      .get('/api/relation/invoicingvia/invoicedRelations', {
        params: {
          id: relationId,
          sort: 'mainRelation.displayName',
          sortDesc: true,
          ...parameters,
        },
      })
      .then(({ data }) => {
        if (!data) return;

        this.setState(state => ({
          ...state,
          relations: parameters.page > 0 ? [...state.relations, ...data] : [...data],
        }));
        return data;
      })
      .catch(error => handleHttpError(intl)(error));
  };
  render() {
    const { show, intl } = this.props;
    const { relations, showAssignments, initialSearchParameters } = this.state;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.InvoicedRelations)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={this.closeModal}
      >
        <div className="invoicedRelationsModalContainer" ref={ref => (this.scrollParentRef = ref)}>
          <ScrollableTable
            loadItems={searchParams => this.loadRelations(searchParams)}
            initialSearchParams={initialSearchParameters}
            items={relations}
            useWindow={false}
            renderTBody
            renderRow={item => this.renderRelation(item)}
            scrollParentRef={this.scrollParentRef}
          >
            <ColumnHeader title={intl.formatMessage(messages.Relation)} />

            {showAssignments ? (
              <ColumnHeader
                title={intl.formatMessage(messages.Assignment)}
                className="file-name-column text-nowrap"
              />
            ) : null}
          </ScrollableTable>
        </div>
      </OkCancelModal>
    );
  }
}

export default injectIntl(InvoicedRelationsModal);
